export default __webpack_public_path__ + "static/ws-165931ef35d1ff01b7d09f258512a6f7.svg";